module.exports = __webpack_public_path__ + "img/logo-long.4c27a672.svg";